<template>
  <div>
    <image-gallery :images='images' v-on='$listeners' />
    <infinite-loading @infinite="onLoadMore" />
    <div class="h-24" />
  </div>
</template>
<script>
import ImageGallery from '@ui/molecules/ImageGallery.vue';
export default {
  props: {
    images: {
      type: Array,
      required: true
    },
    loadMore: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      busy: true
    }
  },
  components: {
    ImageGallery
  },
  methods: {
    async onLoadMore($state) {
      const remaining = await this.loadMore();
      if (remaining > 0) {
        $state.loaded();
      } else {
        $state.complete();
      }
    }
  }

}
</script>
